// extracted by mini-css-extract-plugin
export default {"editItemsHolder":"QVGiAz"};